$(document).ready(function() { 

    $('.side-nav-link-container').click(function() {
        $('.side-nav').hide();
    });
    
    // if (sessionStorage.getItem('popupSeen') == null) {
    //     $('#cookie-popup').css('display', 'block');
    //     $('#cookie-popup').slideDown(500);
    // }

    // $('.cookie-popup-close').click(function() {
    //     try {
    //         sessionStorage.setItem('popupSeen', 'true');
    //     }
    //     catch(err) {}
    //     $('#cookie-popup').slideUp(500);
    // });
    
    // setTimeout(function(){ try {sessionStorage.setItem('popupSeen', 'true'); } catch(err) {} $('#cookie-popup').slideUp(500); }, 10000);

    if ($('.cta-main').hasClass('white-cta-main')) {
        $('.cta-main').addClass('fs-xs-black');
    } else {
        $('.cta-main').addClass('fs-xs-white');
    }

    if ($('body').is('.home')) {
        $('#home_amount_picker').on('show.bs.modal', function (event) {
            $('.modal .modal-content').css('overflow-y', 'auto'); 
            $('.modal .modal-content').css('height', $(window).height() * 0.95);
        });
        $(".who-we-are-footer-link").click(function () {
            $('html, body').animate({'scrollTop': $('#who-we-are-section').offset().top - 40}, 0.1);
        });
        // $(window).load(function () {
        //     // Remove the # from the hash, as different browsers may or may not include it
        //     var hash = location.hash.replace('#', '');
        //     if (hash != '') {
        //         // Clear the hash in the URL
        //         // location.hash = '';   // delete front "//" if you want to change the address bar
        //         $('html, body').animate({scrollTop: $('#who-we-are-section').offset().top - 40}, 0.1);
        //     }
        // });
    } else {
        $(".who-we-are-footer-link").click(function () {
            window.location.href = "/#who-we-are";
        });
    }

});